import { useMatrixCreationStore } from '../data/matrix-creation-store';
import { createMatrix } from '../domain/matrix-creation-provider';
import { MatrixCreationType } from '../matrix-creation-interfaces';
import { jsonStringify } from '../../../../../domain/openu-provider';

const MatrixCreationView = () => {

    const params = useMatrixCreationStore(store => store.params);
    const matrixCreationType = useMatrixCreationStore(store => store.matrixCreationType);
    const result = createMatrix(params, matrixCreationType);

    return (
        <div className="flex gap-4 items-start">
            {
                result &&
                <div className="flex flex-start">
                    <div className="mr-6">
                        <div className="text-xl mb-4 font-bold">
                            {
                                matrixCreationType === MatrixCreationType.RatioOfMismatches &&
                                <span>Dissimilarity Matrix using RatioOfMismatches</span>
                            }

                            {
                                matrixCreationType === MatrixCreationType.DissimilarityMatrixByManhattanDistance &&
                                <span>Dissimilarity Matrix By Manhattan Distance</span>
                            }

                            {
                                matrixCreationType === MatrixCreationType.DissimilarityMatrixByEuclideanDistance &&
                                <span>Dissimilarity Matrix By Euclidean Distance</span>
                            }
                        </div>

                        <table>
                            <thead>
                            <tr>
                                <td className="text-center border p-4 bg-slate-100">&nbsp;</td>
                                {
                                    result.rowNames.map((name, i) => {
                                        return (
                                            <td
                                                className="text-center border p-4 bg-slate-100"
                                                key={ `row-name-${ i }`}>
                                                { name }
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                result.matrix.map((row, ri) => {
                                    return (
                                        <tr key={ `row-${ ri }`}>
                                            <td className="text-center border p-4 bg-slate-100">
                                                {
                                                    result.rowNames[ri]
                                                }
                                            </td>
                                            {
                                                row.map((value, ci) => {
                                                    return (
                                                        <td
                                                            className={ `text-center border p-4 ${ ri === ci ? 'bg-sky-100' : 'bg-white'}` }
                                                            key={ `row-${ ri }-col-${ ci }`}>
                                                            { value }
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>

                        <div className="border p-4 my-4 whitespace-pre">
                            {
                                jsonStringify(params)
                            }
                        </div>
                    </div>

                    <div>
                        <div className="text-xl mb-4 font-bold">Calculations</div>
                        {
                            result.calculations.map((calculation, i) => {
                                return (
                                    <div key={ `calc-${ i }` }>
                                        { calculation }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }
        </div>
    )
};

export default MatrixCreationView;